import { Component, Input, Output, EventEmitter, InputSignal, input } from '@angular/core';
import { SHARED_MODULES } from '../../../shared.';
import { SvgIconComponent } from 'angular-svg-icon';
import { LoaderComponent } from '../loader/loader.component';

type IconTypes = 'primary' | 'secondary' | 'negative' | 'danger' | 'success';

@Component({
    selector: 'ph-icon',
    templateUrl: './ph-icon.component.html',
    styleUrls: ['./ph-icon.component.scss'],
	imports: [SHARED_MODULES, SvgIconComponent, LoaderComponent],
    standalone: true
})

export class PhIconComponent {

    loading: InputSignal<boolean> = input<boolean>(false);
	@Input() icon: string = 'default';
	@Input() type: IconTypes = 'secondary';
	@Input() color: string = '';
	@Input() blocked: boolean = false;
	@Input() disabled: boolean = false;
	@Input() active: boolean = false;
	@Input() negative: boolean = false;
	@Input() hover: boolean = false;
	@Input() width: number = 20;
	@Input() height: number = 20;
	@Input() iconClass: string;

	@Output() iconClick: EventEmitter<MouseEvent> = new EventEmitter<MouseEvent>();
}